<div class="report-container pdf-export">
  <app-reportes-title [pageData]="pageData()"></app-reportes-title>

  <app-report-controls
    [guideId]="'guia-i'"
    [hasData]="respondedCountSignal() > 0"
    [disableCategories]="true"
    [isExporting]="isExporting"
    (scenariosChange)="scenarios = $event"
    (hasAppliedFiltersChange)="hasAppliedFilters = $event"
    (analysisModeChange)="analysisMode = $event"
    (exportPdf)="exportToPdf()">
  </app-report-controls>
  <div style="margin:20px"></div> <!-- Se agrega para exportacion a pdf. Se pueda renderizar bien -->

  @let responded = respondedCountSignal();

  @if (responded > 0) {
    @if (!hasAppliedFilters) {
      @let total = (totalEmployees$ | async) ?? 0;
      @let evaluados = (evaluados$ | async) ?? 0;
      @let conATS = (conAts$ | async) ?? 0;
      @let info = (razonOrg$ | async);
      @let cards = (leftCards$ | async);

      <div class="guia-grid">
        <div class="grid-item campaign-cards">
          @if (cards) {
            @for (c of cards; track c.subtitulo) {
              <app-card-campana-component
                [titulo]="c.titulo"
                [subtitulo]="c.subtitulo"
                [icon]="c.icon"
                [colorIcon]="c.colorIcon"
                [class.small-icon]="['Días para finalizar', 'Campaña', 'Nivel de cumplimiento'].includes(c.subtitulo)">
              </app-card-campana-component>
            }
          }
        </div>

        <div class="grid-item">
          <app-donut-card
            [title]="evaluatedDonutContent().title"
            [primaryLabel]="evaluatedDonutContent().primaryLabel"
            [secondaryLabel]="evaluatedDonutContent().secondaryLabel"
            [primaryCount]="evaluados"
            [totalCount]="total"
            [colors]="evaluatedDonutColors()">
          </app-donut-card>
        </div>

        <div class="grid-item">
          <app-info-card
            class="ats-card"
            [title]="corporateContent()?.title ?? '' "
            [icon]="rzoIcon"
            iconAriaLabel="Información">
            @if (info) {
              <ul class="info-list">
                <li><strong>{{ corporateContent()?.companyNameLabel }}</strong> {{ info.companyName }}</li>
                <li><strong>{{ corporateContent()?.evaluationLabel }}</strong> {{ info.evaluation }}</li>
                <li><strong>{{ corporateContent()?.workersLabel }}</strong> {{ info.totalEmployees }}</li>
                <li><strong>{{ corporateContent()?.metodologyLabel }}</strong> {{ info.methodology }}</li>
                <li><strong>{{ corporateContent()?.campaignStartLabel }}</strong> {{ info.start }}</li>
                <li><strong>{{ corporateContent()?.campaignEndLabel }}</strong> {{ info.end }}</li>
                <li><strong>{{ corporateContent()?.campaignDurationLabel }}</strong> {{ info.durationDays }} días</li>
              </ul>
            } @else {
              <div>{{ corporateContent()?.loadingLabel }}</div>
            }
          </app-info-card>
        </div>

        <div class="grid-item">
          <app-info-card
            class="ats-card"
            [title]="severeTraumaticEventContent()?.title ?? '' "
            [icon]="atsIcon"
            iconAriaLabel="Información">
            <p>{{ severeTraumaticEventContent()?.descriptionPartOne }}</p>
            <p>{{ severeTraumaticEventContent()?.descriptionPartTwo }}</p>
            <p>{{ severeTraumaticEventContent()?.descriptionPartThree }}</p>
          </app-info-card>
        </div>

        <div class="grid-item">
          <app-donut-card
            [title]="atsDonutContent().title"
            [primaryLabel]="atsDonutContent().primaryLabel"
            [secondaryLabel]="atsDonutContent().secondaryLabel"
            [primaryCount]="conATS"
            [totalCount]="total"
            [colors]="atsDonutColors()">
          </app-donut-card>
        </div>

        <div class="grid-item">
          <app-info-card
            class="ats-card"
            [title]="nextStepsContent()?.title ?? '' "
            [icon]="spIcon"
            iconAriaLabel="Información">
            <p>{{ nextStepsContent()?.descriptionPartOne }}</p>
            <ol class="steps">
              <li>
                <span class="step-heading">{{ nextStepsContent()?.firstStepTitle }}</span>
                <p>{{ nextStepsContent()?.firstStepDescription }}</p>
              </li>
              <li>
                <span class="step-heading">{{ nextStepsContent()?.secondStepTitle }}</span>
                <p>{{ nextStepsContent()?.secondStepDescription }}</p>
              </li>
              <li>
                <span class="step-heading">{{ nextStepsContent()?.thirdStepTitle }}</span>
                <p>{{ nextStepsContent()?.thirdStepDescription }}</p>
              </li>
              <li>
                <span class="step-heading">{{ nextStepsContent()?.fourthStepTitle }}</span>
                <p>{{ nextStepsContent()?.fourthStepDescription }}</p>
              </li>
              <li>
                <span class="step-heading">{{ nextStepsContent()?.fifthStepTitle }}</span>
                <p>{{ nextStepsContent()?.fifthStepDescription }}</p>
              </li>
            </ol>
          </app-info-card>
        </div>
      </div>
    } @else {
      <div class="pdf-export">
        <app-report-scenario
          [guideId]="'guia-i'"
          [campaignId]="campaignId()"
          [scenarios]="scenarios"
          (removeScenario)="removeScenario($event)">
        </app-report-scenario>
      </div>
    }
  } @else {
    <app-empty-state></app-empty-state>
  }
</div>
